import { TableCell, TableRow } from '@material-ui/core';
import { FieldArrayRenderProps } from 'formik';
import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { ISPUBudgetValueFormValue } from '../../../../@types/model/transformer/budget';
import { ITransformerCompany } from '../../../../@types/model/transformer/transformer';
import AppFunctionsService from '../../../../services/appFunctionsService';
import TextFormFastField from '../../../customComponents/form/TextFormFastField';

interface ISPUBudgetFieldArrayProps extends FieldArrayRenderProps {
    hideDetail ?: boolean;

    company : ITransformerCompany | null;
    area : string | null;
    transformer : string | null;
    accountNumber : string | null;
    period : number | null;

    currentPage : number;
    rowsPerPage : number;
}

const SPUBudgetFieldArray = (props : ISPUBudgetFieldArrayProps) : React.ReactElement => {

    const getFilteredValues = useMemo<Array<ISPUBudgetValueFormValue>>(() => {
        const {
            currentPage,
            rowsPerPage,
            company,
            area,
            transformer,
            accountNumber,
            period,
        } = props;

        return props.form.values.values
            .filter((x : ISPUBudgetValueFormValue) => !company || x.transformer.Company?.id === company.id)
            .filter((x : ISPUBudgetValueFormValue) => !area || x.transformer.Division === area)
            .filter((x : ISPUBudgetValueFormValue) => !transformer || x.transformer.EPNumber === transformer)
            .filter((x : ISPUBudgetValueFormValue) => !accountNumber || x.transformer.AccountNumber === accountNumber)
            .filter((x : ISPUBudgetValueFormValue) => !period || x.month === period)
            .slice((currentPage * rowsPerPage), currentPage * rowsPerPage + rowsPerPage);
    }, [props.form.values.values, props.currentPage, props.rowsPerPage, props.company, props.area, props.transformer, props.accountNumber, props.period]);

    return (
        <>
            {getFilteredValues
                .map((n) : React.ReactElement => (
                    <TableRow key={`values_${n.index}`} className={'data-row'}>
                        <TableCell className='fixed' width={80}>
                            {
                                AppFunctionsService.formatDateTimeToMonthYearOnly(n.month)
                            }
                        </TableCell>
                        <TableCell className='fixed' width={100}>
                            {
                                n.transformer.Company?.name ?? ''
                            }
                        </TableCell>
                        <TableCell className='fixed' width={150}>
                            {
                                n.transformer.Division
                            }
                        </TableCell>
                        <TableCell className='fixed' width={100}>
                            {
                                n.transformer.EPNumber
                            }
                        </TableCell>
                        {
                            !props.hideDetail &&
                            <>
                                <TableCell className='fixed' width={350}>
                                    {
                                        n.transformer.SubArea
                                    }
                                </TableCell>
                                <TableCell className='fixed' width={200}>
                                    {
                                        n.transformer.AccountNumber
                                    }
                                </TableCell>
                            </>
                        }
                        <TableCell className='fixed lwb new'>
                            <TextFormFastField
                                inputProps={{
                                    className: 'cw fwb',
                                    style: {
                                        textAlign: 'center',
                                    },
                                }}
                                id={`values.${n.index}.budget`}
                                name={`values.${n.index}.budget`}
                                fullWidth
                                required
                                type={'number'}
                                color='white'
                            />
                        </TableCell>
                        <TableCell className='fixed lwb comment'>
                            <TextFormFastField
                                inputProps={{
                                    className: 'cw fwb',
                                }}
                                id={`values.${n.index}.comment`}
                                name={`values.${n.index}.comment`}
                                fullWidth
                                color='white'
                            />
                        </TableCell>
                    </TableRow>
                ))}
        </>
    );
};

export default SPUBudgetFieldArray;
